import { baseUrl, GetHeaders, handleResponse, handleError } from "../common/ApiUtils";

const apiUrl = baseUrl + "PresidentsClub";

export function getRevenueLeaders(userId = null) {
  if (userId) {
    return fetch(`${apiUrl}/revenueleaders/${userId}`, GetHeaders())
      .then(handleResponse)
      .catch(handleError);
  }
  
  return fetch(`${apiUrl}/revenueleaders`, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getRevenueLeadersAdmin() {
  return fetch(`${apiUrl}/revenueleadersadmin`, GetHeaders())
  .then(handleResponse)
  .catch(handleError);
}

export function getUtilizationLeaders(userId = null) {
  if (userId) {
    return fetch(`${apiUrl}/utilizationleaders/${userId}`, GetHeaders())
      .then(handleResponse)
      .catch(handleError);
  }

  return fetch(`${apiUrl}/utilizationleaders`, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getUtilizationLeadersAdmin() {
  return fetch(`${apiUrl}/utilizationleadersadmin`, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}
